<template>
    <div class="barcode-produce">
        <div class="barcode-produce-tabs">
            <div
                :class="['tabs-btn', { active: tabType === 'orgin' }]"
                @click="changeTab('orgin')"
            >
                原材料
            </div>
            <div class="line"></div>
            <div
                :class="['tabs-btn', { active: tabType === 'key' }]"
                @click="changeTab('key')"
            >
                关键件
            </div>
        </div>
        <!-- <div class="barcode-produce-context" v-if="!isEmpty"> -->
        <div class="barcode-produce-context">
            <div class="produce-context-top flex-row">
                <div class="top-item flex-row">
                    <span class="label"> 车间名称：</span>
                    {{
                        tabType === 'orgin'
                            ? mobileMaterialDto.workshop_DESC
                            : mobilePartDto.workshop_DESC
                    }}
                </div>
                <div class="top-item flex-row">
                    <span class="label"> 产线名称：</span>
                    {{
                        tabType === 'orgin'
                            ? mobileMaterialDto.line_DESC
                            : mobilePartDto.line_DESC
                    }}
                </div>
            </div>
            <!-- 这个是循生产卡片等接口数据来在整理  -->
            <div class="content-list" v-show="tabType === 'orgin'">
                <p class="content-list-acount">
                    关键BOM物料({{  mobileMaterialDto.mo_BOM ? mobileMaterialDto.mo_BOM.length : 0 }})
                </p>
                <div
                    class="content-list-item"
                    v-for="(item, index) in mobileMaterialDto.mo_BOM"
                    :key="index"
                >
                    <div class="content-item-row flex-row">
                        <span class="label"> 物料：</span>
                        {{ item.mitem_CODE || '--' }} /
                        {{ item.mitem_DESC || '--' }}
                    </div>
                    <div class="content-item-row flex-row">
                        <span class="label"> 供应商：</span>
                        {{ item.supplier_NAME || '--' }}
                    </div>
                </div>
            </div>
            <div class="content-list" v-show="tabType === 'key'">
                <p class="content-list-acount">
                    关键件物料({{ mobilePartDto.mitem_KEYPART ? mobilePartDto.mitem_KEYPART.length : 0 }})
                </p>
                <div
                    class="content-list-item"
                    v-for="(item, index) in mobilePartDto.mitem_KEYPART"
                    :key="index"
                >
                    <div class="content-item-row flex-row">
                        <span class="label"> 关键件条码：</span>
                        {{ item.materialSN || '--' }}
                    </div>
                    <div class="content-item-row flex-row">
                        <span class="label"> 关键件：</span>
                        {{ item.mitem_CODE || '--' }} /
                        {{ item.mitem_DESC || '--' }}
                    </div>
                    <div class="content-item-row flex-row">
                        <span class="label"> 采集时间：</span>
                        {{ item.datetimeCREATED }}
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="empty" v-else>
        <image class="empty-image" mode="widthFix" :src="require(`@/static/barcodeImage/no-search.png`)" />
        <div>暂无数据</div>
        </div> -->
    </div>
</template>

<script>
import { manufactSearch } from '@/modules/sn/api/lcbsManagement.js';
export default {
    name: 'BarcodeProduce',
    props: {
        barcodeNo: {
            type: String,
            default: () => '311611004541B221A01524'
        }
    },
    computed: {
        isEmpty() {
            let flag = true;
            if (
                this.tabType === 'orgin' &&
                Array.isArray(this.mobileMaterialDto.mo_BOM) &&
                this.mobileMaterialDto.mo_BOM.length > 0
            ) {
                flag = false;
            }
            if (
                this.tabType === 'key' &&
                Array.isArray(this.mobilePartDto.mitem_KEYPART) &&
                this.mobilePartDto.mitem_KEYPART.length > 0
            ) {
                flag = false;
            }
            return flag;
        }
    },
    data() {
        return {
            tabType: 'orgin',
            dataList: [],
            mobileMaterialDto: {}, // 原材料信息
            mobilePartDto: {} // 关键部件信息
        };
    },
    mounted() {
        this.getData(this.barcodeNo);
    },
    methods: {
        changeTab(type) {
            this.tabType = type;
        },
        getData(barcode) {
            manufactSearch({ barcode }).then((res) => {
                if (res && +res.code === 0) {
                    this.setData(res.data);
                }
            });
        },
        setData(data) {
            this.mobileMaterialDto = data.mobileMaterialDto;
            this.mobilePartDto = data.mobilePartDto;
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-produce {
    padding: 20px;
    font-size: 12px;
}
.flex-row {
    display: flex;
    align-items: baseline;
}
.barcode-produce-tabs {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    font-weight: 600;
    .tabs-btn {
        position: relative;
    }
    .tabs-btn::after {
        content: '';
        display: block;
        position: absolute;
        left: 46%;
        bottom: -10px;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        // background-color: #4285f5;
    }
    .active {
        color: #4285f5;
    }
    .active::after {
        background-color: #4285f5;
    }
    .line {
        margin: 0 15px;
        width: 1px;
        height: 15px;
        background: #e5e5e5;
    }
}
.barcode-produce-context {
    margin-top: 18px;
    .label {
        flex-shrink: 0;
        color: #888888;
    }
}
.produce-context-top {
    .top-item {
        width: 350px;
    }
}
.content-list {
    margin-top: 12px;
    .content-list-acount {
        font-size: 12px;
        color: #333333;
        font-weight: 600;
    }
    .content-list-item {
        margin-top: 8px;
        padding: 12px;
        border-radius: 2px;
        background: #f9f9f9;
    }
    .content-item-row {
        margin: 4px 0;
        .label {
            width: 50px;
            text-align: right;
        }
    }
}
</style>
